// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';

import {ALLOWED_TIMEZONE} from 'graphql-client/__generated/GeneratedEnumMaps';
import {AllowedTimezone} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  institutionInfoLinksByUrl,
  LicensedInstitutionInfoLink,
} from 'help/institutions/InstitutionModalConstants';
import {Institution} from 'institutions/InstitutionConstants';
import InstitutionSelector from 'institutions/InstitutionSelector';
import NotificationPreferencesSection from 'notifications/preferences/NotificationPreferencesSection';
import ProfileAPISection from 'profile/ProfileAPISection';
import ProfileLocalePicker from 'profile/ProfileLocalePicker';
import ProfileMfaSection from 'profile/ProfileMfaSection';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import WarehouseLogins from 'warehouse/WarehouseLogins';

class SelectedInstitution extends Backbone.Model {
  institution!: Institution | null;

  override initialize({institution}: {institution: Institution | null}): void {
    this.institution = institution;
  }
}

class ProfileSettingsView extends Backbone.View<Backbone.Model> {
  initialInstitution!: Institution | null;
  selectedInstitution!: SelectedInstitution;

  static initClass(): void {
    this.prototype.el = '#settings';
    this.prototype.events = {
      // @ts-expect-error: This is a legit JQueryEventObject but it is not being recognized by TS
      'submit .add-member-form': 'handleAddMember',
    };
  }

  override initialize(): void {
    this.initialInstitution = window.bootstrap!.entity!.institution;
    this.selectedInstitution = new SelectedInstitution({institution: this.initialInstitution});
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionInfoLink);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionSelector);
  }

  mountInstitutionSelector(): void {
    const $mount = this.$('.js-institution.react-mount');

    if ($mount.length) {
      const model = this.selectedInstitution;
      renderToDOM(
        <InstitutionSelector
          placeholder="No institution selected"
          allowLeaving={!this.initialInstitution?.licensed}
          value={model.get('institution')}
          onChange={(institution) => model.set({institution})}
          className="u-small-spacing-bottom"
          disabled={this.initialInstitution?.licensed}
        />,
        $mount[0]
      );
    }
  }

  mountLanguageTagPicker(): void {
    const $mount = this.$('.js-language-tag.react-mount');
    const name = 'language_tag';
    if ($mount.length) {
      renderToDOM(
        <ProfileLocalePicker
          name={name}
          // This input will exist at first, and then get clobbered by `ProfileLocalePicker`, which creates and
          // updates its own hidden input for the form
          initialValue={$mount.find(`input[name=${name}]`).val()}
        />,
        $mount[0]
      );
    }
  }

  mountWarehouseLogins(): void {
    const $mount = this.$('.js-warehouse.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(<WarehouseLogins />, $mount[0]);
  }

  mountNotificationsOptOutSetting(): void {
    const $mount = this.$('.js-notifications-opt-out-setting.react-mount');
    if (!$mount.length) {
      return;
    }
    const deliveryTimezone = Object.keys(ALLOWED_TIMEZONE).find(
      (key: AllowedTimezone) => ALLOWED_TIMEZONE[key] === window.bootstrap!.notificationDeliveryTimezone
    ) as AllowedTimezone;
    renderToDOM(
      <NotificationPreferencesSection
        notificationOptOutPreferences={window.bootstrap!.notificationOptOutPreferences}
        deliveryTimezonePreference={deliveryTimezone}
      />,
      $mount[0]
    );
  }

  mountAPISection(): void {
    const $mount = this.$('.js-api.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(<ProfileAPISection />, $mount[0]);
  }

  mountMfaSection(): void {
    const $mount = this.$('.js-mfa.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(
      <ProfileMfaSection
        mfaEnabled={window.bootstrap?.mfa_enabled ?? false}
        canDisableMfa={window.bootstrap?.can_disable_mfa ?? false}
      />,
      $mount[0]
    );
  }

  mountInstitutionInfoLink(): void {
    const $mount = this.$('.js-institution-info-link');
    if (!$mount.length) {
      return;
    }
    const institution: Institution | null = this.selectedInstitution.get('institution');
    const urlIdentifier = institution && institution.urlIdentifier;

    const urlInfoLink: (() => JSX.Element) | undefined =
      // @ts-expect-error urlIdentifier is probably not `broad`, the only key in `institutionInfoLinksByUrl`.
      // So we can expect to get back `undefined` here
      urlIdentifier && institutionInfoLinksByUrl[urlIdentifier];

    if (urlInfoLink) {
      renderToDOM(React.createElement(urlInfoLink), $mount[0]);
    } else if (institution && institution.licensed) {
      renderToDOM(<LicensedInstitutionInfoLink institution={institution} />, $mount[0]);
    } else {
      this.unmountInstitutionInfoLink($mount[0]);
    }
  }

  unmountInstitutionInfoLink($el: Element): void {
    renderToDOM(<div />, $el);
  }

  override render(): this {
    this.mountInstitutionSelector();
    this.mountInstitutionInfoLink();
    this.mountLanguageTagPicker();
    this.mountAPISection();
    this.mountMfaSection();

    this.mountWarehouseLogins();
    this.mountNotificationsOptOutSetting();

    return this;
  }
}

ProfileSettingsView.initClass();

export default ProfileSettingsView;
